import { GuestModel } from 'api-hooks/guest';
import colorConstant from 'common/styles/styles.colors';
import { capitalize } from 'common/utils/string';
import Separator from 'components/common/separator';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useDate from 'hooks/use-date';
import useDrawer from 'hooks/use-drawer';
import {
  CardContainer,
  FullContainer,
  Title,
  NotificationBadge,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

import DocumentPanel from './document-panel';
import { DescriptionText, Tag } from './styles';

interface Props {
  data: GuestModel;
}

export default function GuestInformation(props: Props) {
  const { data } = props;
  const { t } = useTranslation();

  const drawer = useDrawer();
  const formatDate = useDate();

  const onShowDrawer = () => {
    drawer.showCustom({
      render: (onClose) => <DocumentPanel guest={data} onClose={onClose} />,
    });
  };

  return (
    <CardContainer>
      <SectionContainer>
        <Title variant="HeadingXSmall">{t('guest:guest_information')}</Title>
        <Separator gap={16} />
        <Button buttonType="secondary" onClick={onShowDrawer}>
          {t('guest:show_guest_document')}
        </Button>
      </SectionContainer>
      <Separator gap={16} />

      <FullContainer
        $style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <Text variant="LabelSmall">
          {`${capitalize(data.title)} ${data.name} ${
            data.alias ? `- ${data.alias}` : ''
          }`}
        </Text>
        <Separator gap={8} />
        <NotificationBadge status="main">
          {data.category.toUpperCase()}
        </NotificationBadge>
      </FullContainer>
      <Separator gap={16} />
      <FullContainer>
        <DescriptionText variant="LabelXSmall">{data.phone}</DescriptionText>
        <DescriptionText variant="LabelXSmall">{data.email}</DescriptionText>
        {data.birthDate && (
          <DescriptionText variant="LabelXSmall">
            {formatDate(data.birthDate)}
          </DescriptionText>
        )}
      </FullContainer>
      {!!data.preferences.length && (
        <>
          <Separator gap={20} />
          <FullContainer
            $style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              gap: '8px',
            }}
          >
            {data.preferences.map((preference, index) => (
              <Tag
                key={index}
                $style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Text variant="LabelSmall" color={colorConstant.primaryDefault}>
                  {preference.name}
                </Text>
              </Tag>
            ))}
          </FullContainer>
        </>
      )}
    </CardContainer>
  );
}
